export type CoverageTier = 'Basic' | 'Standard' | 'Deep';

export const COVERAGE_TIER_THRESHOLDS: Record<CoverageTier, number> = {
  Basic: 40,
  Standard: 70,
  Deep: 95,
};

/** Tiers heaviest-first, for meters and pickers that render the whole ladder. */
export const COVERAGE_TIERS: CoverageTier[] = ['Basic', 'Standard', 'Deep'];

/** The tier a coverage percentage earns. */
export function coverageTierForPct(pct: number): CoverageTier {
  if (pct >= COVERAGE_TIER_THRESHOLDS.Deep) return 'Deep';
  if (pct >= COVERAGE_TIER_THRESHOLDS.Standard) return 'Standard';
  return 'Basic';
}
